import React, { useState, useEffect } from 'react';
import { TABLA_OBJETIVOS_ADMIN } from 'Queries';
import {
  DashboardContextConsumer,
  DownloadButton,
} from 'Utils';

import { Tabs as AntTabs, Alert as AntAlert, Progress as ProgressBar } from 'antd';
import styled from '@emotion/styled';
import { useLazyQuery, } from '@apollo/client';
import { ObjectivesAdminLegend } from './ObjectivesAdminLegend';
import { ObjectivesAdminSummary } from './ObjectivesAdminSummary';

const { TabPane } = AntTabs;

export const ObjectivesAdminTable = ({ distributorsHesa, ...props }) => (
  <DashboardContextConsumer>
    {dashboardProps => <ResumeTables {...dashboardProps} {...props} distribuidoresHesa={props.distribuidores} />}
  </DashboardContextConsumer>
);


export const ResumeTables = ({
  navigate,
  type,
  year: ano,
  distribuidoresHesa
}) => {
  const [empleados, setEmpleados] = useState([]);
  const [niveles, setNiveles] = useState([]);
  const [fecha, setFecha] = useState([]);
  const distribuidores = distribuidoresHesa;
  const [bigLoadingFinished, setBigLoadingFinished] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [globalList, setGlobalList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [chargingData, setCharging] = useState(false);
  const [transformedFilteredList, setTransformedFilteredList] = useState([]);
  const [progress, setProgress] = useState(0);

  const [remainingList, setRemainingList] = useState([]);
  const [filter, setFilter] = useState({});
  const divisor = 1;

  const [stopper, setStopper] = useState(false);
  const [pauser, setPauser] = useState(false);
  const transformData = (data) => {
    const transformedData = {};
    data.forEach((dato) => {
      const clave = `${dato.codigoDistribuidor}-${dato.codObjetivo}-${dato.nombreObjetivo}`;
      if (!transformedData[clave]) {
        transformedData[clave] = [];
      }
      transformedData[clave].push(dato);
    });
    return Object.keys(transformedData).map((clave) => {
      const partes = clave.split('-');
      const distribuidor = partes[0];
      const codObjetivo = partes[1];
      const nombreObjetivo = partes.slice(2).join('-'); // Recupera el resto de la cadena como nombreObjetivo
      return {
        distribuidor,
        codObjetivo,
        nombreObjetivo,
        datos: transformedData[clave],
      };
    });
  };
  

  const header_TABLA = [
    { label: 'Código distribuidor', key: 'codigoDistribuidor' },
    { label: 'Distribuidor', key: 'nombreDistribuidor' },
    { label: 'Objetivo', key: 'nombreObjetivo' },
    { label: 'Por equipo', key: 'porEquipo' },
    { label: 'Nivel', key: 'nivel' },
    { label: 'Comercial', key: 'comercialHesa' },
    { label: 'Tipo de Objetivo', key: 'tipoObjetivo' },
    { label: 'Fecha Periodo', key: 'fechaPeriodo' },
    { label: 'Cantidad Objetivo', key: 'cantidadObjetivo' },
    { label: 'Cantidad Actual', key: 'cantidadActual' },
    { label: '% Cumplimiento', key: 'cumplimiento' },
    { label: 'Incentivo Teórico', key: 'incentivoTeorico' },
    { label: 'Incentivo Real', key: 'incentivoReal' },
    { label: '% Incentivo', key: 'incentivo' },
    { label: 'Estado', key: 'estado' }
  ]

  const resetList = () => {
    setProgress(0);
    setRemainingList([]);
    setDataList([]);
    setGlobalList([]);
    setFilteredList([]);
  };

  const callNewKpis = (desde, hasta) => {
    setFecha([desde, hasta]);
  };

  const parseFechaPeriodo = (fechaPeriodo) => {
    const [fechaInicio, fechaFin] = fechaPeriodo.split(' - ');
    const [diaInicio, mesInicio, anioInicio] = fechaInicio.split('/').map(Number);
    const [diaFin, mesFin, anioFin] = fechaFin.split('/').map(Number);
    return { mesInicio, mesFin };
  };

  const [getSummaryList, { error, loading }] = useLazyQuery(TABLA_OBJETIVOS_ADMIN, {
    onCompleted: (data) => {
      if (data && stopper === false && pauser === false) {
        let datos = data.TablaObjetivosAdmin;
        if (datos.length > 0) {
          datos = datos.filter(item => {
            if (item.codTipoPeriodo === 'A' || item.codTipoPeriodo === 'P' || item.codTipoPeriodo === 'F') {
              return item;
            }
            const { mesInicio, mesFin } = parseFechaPeriodo(item.fechaPeriodo);
            return item.mes >= mesInicio && item.mes <= mesFin;
          });
          datos = datos.map(item => ({ ...item, porEquipo: item.codAgrupacion === 'C' ? 'No' : 'Sí' }));
        }
        setDataList(prevDataList => [...prevDataList, ...datos])
      }
    }
  });

  const sortLista = (datos) => {
    // Ordenar la lista por distribuidor, código objetivo, mes
    datos.sort((a, b) => {
      if (a.codigoDistribuidor < b.codigoDistribuidor) {
        return -1;
      }
      if (a.codigoDistribuidor > b.codigoDistribuidor) {
        return 1;
      }
      if (a.codObjetivo < b.codObjetivo) {
        return -1;
      }
      if (a.codObjetivo > b.codObjetivo) {
        return 1;
      }
      if (a.mes < b.mes) {
        return -1;
      }
      if (a.mes > b.mes) {
        return 1;
      }
      return 0;
    });
    return datos;
  }

  const cargarDistribuidores = async () => {
    // Primero, aseguramos que el estado del stopper y pauser esté en falso para continuar con la carga
    setStopper(false);
    setPauser(false);

    let distribs = filter.distribuidor ? [distribuidores.find(d => d.value === filter.distribuidor)] : distribuidores;
    // Iteramos sobre todos los distribuidores
    for (let i = 0; i < distribs.length; i++) {
      // Realizamos la llamada a la API para obtener los datos de cada distribuidor
      await getSummaryList({
        variables: {
          fechaDesde: filter.fechas[0].format('YYYY-MM-DD'),
          fechaHasta: filter.fechas[1].format('YYYY-MM-DD'),
          codDistribuidor: distribs[i].value, // Cod distribuidor a procesar
        }
      });

      // Actualizamos el progreso
      setProgress((i + 1) / distribs.length * 100);
    }
    setBigLoadingFinished(true);
    setCharging(false);
  };

  useEffect(() => {
    if (bigLoadingFinished) {
      setIsLoading(true);
      let sortDataList = sortLista(dataList);
      setGlobalList(sortDataList);
      setFilteredList(sortDataList);
      setRemainingList(sortDataList);
      setBigLoadingFinished(false);
    }
  }, [dataList]);

  useEffect(() => {
    if (globalList.length === 0 && filter.fechas) {
      const cargarDistribuidoresConCallback = async () => {
        setCharging(true);
        await cargarDistribuidores();
      };
      setIsLoading(true);
      cargarDistribuidoresConCallback();
    }
  }, [filter.fechas, filter.distribuidor]);

  useEffect(() => {
    setFilter({ ...filter, nivel: undefined, empleado: undefined })
    setEmpleados([]);
    setNiveles([]);
  }, [filter.distribuidor]);

  const getDesc = (nivel) => {
    switch (nivel) {
      case 'CO':
        return 'Comercial';
      case 'JE':
        return 'Jefe de equipo';
      case 'GE':
        return 'Gerente';
      case 'JV':
        return 'Jefe de ventas';
      default:
        return '';
    }
  };

  useEffect(() => {
    setEmpleados([]);
    setFilter({ ...filter, empleado: undefined })
  }, [filter.nivel])

  const updateNiveles = (list) => {
    const niveles = [...new Map(list.map(item => [item.nivel, { id: item.nivel, desc: getDesc(item.nivel) }])).values()].sort((a, b) => a.id.localeCompare(b.id));
    setNiveles(niveles);
  };

  const updateEmpleados = (list) => {
    const empleados = [...new Set(list.filter(item => item.nivel == filter.nivel).map(item => item.comercialHesa))].map(empleado => {
      return { codEmpleado: empleado, nombreEmpleado: empleado };
    }).sort((a, b) => {
      const nombreA = a.nombreEmpleado.replace(/\d+/g, '').trim();
      const nombreB = b.nombreEmpleado.replace(/\d+/g, '').trim();
      if (nombreA == "Comercial" && nombreB == "Comercial") {
        const numeroA = a.nombreEmpleado.replace(/\D+/g, '');
        const numeroB = b.nombreEmpleado.replace(/\D+/g, '');
        return parseInt(numeroA) - parseInt(numeroB);
      }
      return nombreA.localeCompare(nombreB)
    });
    setEmpleados(empleados);
  }

  useEffect(() => {
    setIsLoading(true);
    let temporalList = globalList;
    // Vamos aplicando cada filtro
    // Codigo distribuidor
    // Tipo período
    if (filter.cuando) {
      temporalList = temporalList.filter(item => filter.cuando === 'M' ? item.codTipoPeriodo === filter.cuando : item.codTipoPeriodo !== 'M');
    }
    // Estado
    if (filter.estado) {
      temporalList = temporalList.filter(item => item.estado === filter.estado);
    }
    // Tipo
    if (filter.tipo) {
      temporalList = temporalList.filter(item => item.codAgrupacion === filter.tipo);
    }
    // idMedida
    if (filter.idMedida && filter.idMedida.length > 0) {
      temporalList = temporalList.filter(item => filter.idMedida.includes(item.codTipoObjetivo));
    }
    if (filter.distribuidor) {
      updateNiveles(temporalList);
    }
    // Nivel
    if (filter.nivel) {
      temporalList = temporalList.filter(item => item.nivel === filter.nivel)
      updateEmpleados(temporalList);
    }
    // Empleado
    if (filter.empleado) {
      temporalList = temporalList.filter(item => item.comercialHesa === filter.empleado)
    }
    setFilteredList(temporalList);
  }, [filter])

  useEffect(() => {
    setFilter({ ...filter, empleado: undefined, nivel: undefined })
  }, [globalList]);

  useEffect(() => {
    setIsLoading(true);
    if (filteredList.length > 0) {
      const transformed = transformData(filteredList); // Aplicas la transformación
      setTransformedFilteredList(transformed);
    }
    else {
      setTransformedFilteredList([]);
    }
  }, [filteredList])

  useEffect(() => {
    setIsLoading(false);
  }, [transformedFilteredList])

  return (
    <div id="contentWidth" style={{ position: 'relative', minWidth: '830px' }}>
      <div>
        {(loading || isLoading) && (
          <Warning
            message=" Es posible que la carga completa de los datos lleve algunos minutos"
            type="warning"
            showIcon
            style={{ width: "545px" }}
          />
        )}

        {!filter.fechas && (
          <Warning
            message=" Seleccione un rango de fechas para comenzar la busqueda de objetivos"
            type="warning"
            showIcon
            style={{ width: "570px" }}
          />
        )}

        <SummaryLegendWrapper>
          <ObjectivesAdminLegend
            filter={filter}
            empleados={empleados}
            distribuidores={distribuidores}
            niveles={niveles}
            setFilter={newFilter => {
              setFilter({ ...filter, ...newFilter });
            }}
            clearFilter={() => {
              resetList();
              setFilter({});
            }}
            isLoading={loading || isLoading || chargingData}
            resetList={resetList}
            callNewKpis={callNewKpis}
          />
        </SummaryLegendWrapper>
        {chargingData && (
          <div style={{ textAlign: 'center', margin: '0 30px', width: '95%' }}>
          <ProgressBar 
            percent={progress.toFixed(2)} 
            format={(percent) => <b style={{color:'#205527'}}>{percent}%</b>} 
            strokeColor={{
              '0%': '#C6F4D6',
              '100%': '#205527',
            }}
            trailColor='#E5E5E5'
          />
        </div>
        )}
        <FollowTabs
          props={{ isLoaded: loading || isLoading || chargingData }}
          activeKey={type}
          >
          <TabPane tab={'OBJETIVOS'} key="objetivos">
            <DownloadButton
              header={header_TABLA} // Aquí añado la cabecera
              body={filteredList}
              forceBody={true}
              loading={loading || isLoading || chargingData}
              setPauser={setPauser}
              setStopper={setStopper}
              stopper={stopper}
              remaining={remainingList.length - divisor}
              call={() => remainingList.pop()}
              />
            <div style={{ marginTop: 20, padding: '0 20px 20px 20px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
              <ObjectivesAdminSummary
                customList={transformedFilteredList}
                firstCol={[{ id: 'distributorCode', text: 'Objetivo' }, { id: 'nombreEmpleado', text: 'Comercial' }]}
                isLoaded={loading || isLoading || chargingData}
                />
            </div>
          </TabPane>
        </FollowTabs>
        <br />
      </div>
    </div>
  );
};

const FollowTabs = styled(AntTabs)`
  .ant-tabs-nav{
    margin: 15px;
    visibility: hidden;
  }
  .ant-tabs-nav .ant-tabs-tab {
    z-index: 105;
    padding: 12px;
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0 0 0 10px;
  }
`;

const Warning = styled(AntAlert)`
  font-size: 17px;
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 110px auto;
  height: 50px;
`;

const SummaryLegendWrapper = styled.div`
  padding: 18px;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 100;
`;
